import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {Avatar, Button, Card, Col, Row, Tooltip} from "antd";
import {Link} from 'react-router-dom'
import {sendNotification} from "../../utils";
import {clearAllTrash, getTrashItems } from "../../actions/TrashAction";

export class DashboardBin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleting: false,
    }
  }

  handleShowDeleting = () => {
    this.setState({
      isDeleting: true,
    });
  }

  handleHiddenDeleting = () => {
    this.setState({
      isDeleting: false,
    });
  }

  onClearAllAssets = () => {
    const { workclient, trashItems, intl } = this.props
    if(trashItems.length === 0){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-no-assets"}));
      return;
    }
    const ids = trashItems.map(e => e._id)
    this.props.clearAllTrash(workclient, ids);
  }

  componentDidUpdate(prevProps) {
    const {intl, workclient} = this.props;
    if(prevProps.loadingClearAllTrash && !this.props.loadingClearAllTrash && !this.props.errorClearAllTrash){
      sendNotification('success', intl, intl.formatMessage({id: "trash-success-clear"}));
      this.props.getTrashItems(workclient)
      this.handleHiddenDeleting();
    }
    if(prevProps.loadingClearAllTrash && !this.props.loadingClearAllTrash && this.props.errorClearAllTrash){
      sendNotification('error', intl, intl.formatMessage({id: "trash-error-clear"}));
      this.handleHiddenDeleting();
    }
  }

  render() {
    const {
      isDeleting
    } = this.state;

    const {
      intl,
      newColor,
      trashItems = [],
      isAdminOrSuperadmin = false
    } = this.props;

    return (
      <React.Fragment>
        {isDeleting ? <Card hoverable style={{minHeight: "295px",border: '3px solid var(--primary-color)'}} >
          <Row gutter={25} style={{marginTop: "30px"}}>
            <Col span={24}>
              <div style={{textAlign: 'center'}}>
                <p style={{ fontSize: 20, color: '#7e7e7e', fontWeight: 500, }}>
                  {
                    intl.formatMessage({id: trashItems.length === 1 ? 'bin_alert_deleting_one' : 'bin_alert_deleting'}).replace('#qty', trashItems.length)
                  }
                </p>
                <div>
                  <Button type="primary" size={'large'} style={{ marginRight: 10, }} onClick={this.onClearAllAssets}>
                    {intl.formatMessage({id: 'yes'}).toUpperCase()}
                  </Button>
                  <Button
                    type="primary"
                    size={'large'}
                    ghost
                    onClick={this.handleHiddenDeleting}
                  >
                    {intl.formatMessage({id: 'no'}).toUpperCase()}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Card> : <Card className="dashboard-bin" title={<p onClick={()=>this.props.history.push("/home/trash")}>{intl.formatMessage({id: 'bin'})}</p>} hoverable style={{minHeight: "295px"}} extra={(
          <Tooltip title={intl.formatMessage({id: "admin-message"})} placement={'left'} theme="outlined">
            <span style={{ cursor: 'pointer', }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 3.28C8.20569 3.28 8.40677 3.34099 8.57779 3.45527C8.74882 3.56955 8.88212 3.73197 8.96083 3.92201C9.03955 4.11204 9.06015 4.32115 9.02002 4.52289C8.97989 4.72463 8.88084 4.90994 8.73539 5.05539C8.58994 5.20084 8.40463 5.29989 8.20289 5.34002C8.00115 5.38015 7.79204 5.35955 7.60201 5.28084C7.41197 5.20212 7.24955 5.06882 7.13527 4.89779C7.021 4.72677 6.96 4.52569 6.96 4.32C6.96 4.04418 7.06957 3.77965 7.26461 3.58461C7.45965 3.38957 7.72417 3.28 8 3.28ZM10.56 11.82C10.56 12.0961 10.3361 12.32 10.06 12.32H6.26C5.98386 12.32 5.76 12.0961 5.76 11.82V11.54C5.76 11.2639 5.98386 11.04 6.26 11.04H7.52V7.52H6.74C6.46386 7.52 6.24 7.29614 6.24 7.02V6.74C6.24 6.46386 6.46386 6.24 6.74 6.24H8.3C8.57614 6.24 8.8 6.46386 8.8 6.74V11.04H10.06C10.3361 11.04 10.56 11.2639 10.56 11.54V11.82Z" fill="#3598CD"/>
              </svg>
            </span>
          </Tooltip>
        )}>
          <Row gutter={25} style={{marginTop: "30px"}}>
            <Col xxl={10} xl={10} lg={24} md={10} sm={24} xs={24}>
              <Avatar size={159}
                src="/images/img_v2/img-bin.svg"
                style={{border: '2px solid #3598CD', background: "#E7F6FF"}}
              />
            </Col>
            <Col xxl={13} xl={13} lg={24} md={13} sm={24} xs={24}>
              <div style={{textAlign: 'left'}}>
                <p><b>{intl.formatMessage({id: 'bin_alert'}).replace('#qty', trashItems.length)}</b></p>
                <p style={{ fontSize: 15, }}>{intl.formatMessage({id: 'bin_desc'})}</p>
                <div>
                  <Link to='/home/trash'>
                    <button
                      className="ant-btn ant-btn-primary" style={{backgroundColor: newColor, borderColor: newColor, marginRight: 10}}>
                      {intl.formatMessage({id: 'go_to_bin'})}
                    </button>
                  </Link>
                  {isAdminOrSuperadmin && <Button
                    type="primary"
                    ghost
                    style={{ padding: '0 20px', borderColor: newColor, color: newColor}}
                    onClick={this.handleShowDeleting}
                  >
                    {intl.formatMessage({id: 'delete'})}
                  </Button>}
                </div>
              </div>
            </Col>
          </Row>
        </Card>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  loadingClearAllTrash: state.trash.loadingClearAllTrash,
  errorClearAllTrash: state.trash.errorClearAllTrash,
  workclient: state.client.workclient,
});

const mapDispatchToProps = {
  getTrashItems,
  clearAllTrash
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardBin)))
